import React from "react"
import PropTypes from "prop-types"
import CircleImage from "components/common/CircleImage"
import GuideRatingStars from "components/common/GuideRatingStars/GuideRatingStars"
import { Icon as FeatherIcon } from "ui/Icon"
import styles from "./GuideRatingInfo.module.css"

const GuideRatingInfo = ({ guide }) => {
  if (!guide) return null

  const name = guide.display_name || guide.company_name

  return (
    <div className="text-end flex-shrink-0">
      <div
        className={`d-inline-flex align-items-center gap-1 text-dark fw-semibold fs-7 rounded-pill py-1 px-2 mb-2 ${styles.topRatedBadge}`}
      >
        <FeatherIcon type="feather" name="Award" color="#212529" width={16} height={16} />
        <span>Top Rated</span>
      </div>
      <div className="hstack gap-2 align-items-center">
        <CircleImage
          src={guide.logo}
          alt={name || "Guide"}
          size={40}
          placeholderIconName="MyProfile"
          className="flex-shrink-0"
          border={false}
        />
        <span className="fs-7 fw-semibold text-dark lh-sm">{name}</span>
        <GuideRatingStars />
      </div>
    </div>
  )
}

GuideRatingInfo.propTypes = {
  guide: PropTypes.shape({
    company_name: PropTypes.string,
    display_name: PropTypes.string,
    logo: PropTypes.string
  })
}

export default GuideRatingInfo
